/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Invoices_DescriptionInputs */

const en_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep an eye on your finances`)
};

const de_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behalte deine Finanzen im Auge`)
};

const es_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vigila tus finanzas`)
};

const fr_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gardez un œil sur vos finances`)
};

const it_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tieni d'occhio le tue finanze`)
};

const pt_br2_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha-se atento às suas finanças`)
};

const pl_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miej oko na swoje finanse`)
};

const hu_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tartsa szemmel pénzügyeit`)
};

const ro_admin_dashboard_empty_state_invoices_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aveti grija de finantele dumneavoastra`)
};

/**
* | output |
* | --- |
* | "Keep an eye on your finances" |
*
* @param {Admin_Dashboard_Empty_State_Invoices_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_invoices_description = /** @type {((inputs?: Admin_Dashboard_Empty_State_Invoices_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Invoices_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_invoices_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_invoices_description(inputs)
	return ro_admin_dashboard_empty_state_invoices_description(inputs)
});
export { admin_dashboard_empty_state_invoices_description as "admin.dashboard.empty_state.invoices.description" }